var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMortgageTransfer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10491",
    "data-name": "Group 10491",
    transform: "translate(-51 -336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10432",
    "data-name": "Group 10432",
    transform: "translate(-328.219 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Sell_house_-_Flaticon-2",
    "data-name": "Search results for Sell house - Flaticon-2",
    transform: "translate(402.033 354.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "outline_copy_2",
    "data-name": "outline copy 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9994",
    "data-name": "Path 9994",
    d: "M16.877,273.428h5.261a.877.877,0,0,0,.877-.877V270.8h3.333l10.439,4.318a.88.88,0,0,0,.258.063v0l12.139-4.92,3.1-1.284a.877.877,0,0,0,.515-1.023,4.225,4.225,0,0,0-5.434-2.983l-.027.009-8.385,3.1-2.915-1.666H38a4.391,4.391,0,0,0,4.3-3.507h5.272a.877.877,0,0,0,.877-.877v-6.558l.374.262,1.006-1.437-1.38-.966v-.07h-.1l-7.289-5.1a.877.877,0,0,0-1.006,0l-7.289,5.1h-.1v.07l-1.38.966,1.006,1.437.374-.262v5.681H23.015v-.877a.877.877,0,0,0-.877-.877H16.877a.877.877,0,0,0-.877.877v12.276a.877.877,0,0,0,.877.877Zm24.656,0,4.28-1.771v.018Zm-.1-12.276H39.674v-4.384h1.754Zm-7.015-6.909,6.138-4.3,6.138,4.3v6.909H43.182v-5.261a.877.877,0,0,0-.877-.877H38.8a.877.877,0,0,0-.877.877v5.261H34.413Zm-11.4,8.663H40.479A2.635,2.635,0,0,1,38,264.659H32.737A.877.877,0,0,0,32.3,266.3L38.44,269.8a.877.877,0,0,0,.739.061l8.754-3.236a2.477,2.477,0,0,1,2.879,1.059l-13.691,5.667L26.857,269.11a.88.88,0,0,0-.335-.066H23.015Zm-5.261-1.754h3.507v10.522H17.754Z",
    transform: "translate(-16 -222.572)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9995",
    "data-name": "Path 9995",
    d: "M89.1,27.4H83.842a.877.877,0,0,0-.877.877v1.754H78.944L65.171,16.257a.877.877,0,0,0-1.24,0,4.6,4.6,0,0,0,0,6.5l.257.257H40.877a.877.877,0,0,0-.877.877V39.674a.877.877,0,0,0,.877.877H66.3a.877.877,0,0,0,.877-.877v-2.63h.724a6.131,6.131,0,0,1,1.765.259l7.781,2.334a.88.88,0,0,0,.252.037h5.261v.877a.877.877,0,0,0,.877.877H89.1a.877.877,0,0,0,.877-.877V28.275A.877.877,0,0,0,89.1,27.4ZM64.649,18.214l4.8,4.8H66.668l-1.5-1.5a2.848,2.848,0,0,1-.522-3.3Zm2.533,10.061h.877a1.754,1.754,0,0,1,0,3.507h-.877ZM65.428,38.8H41.754V24.768H65.428v7.015h-.877a4.389,4.389,0,0,0-4.384,4.384.877.877,0,0,0,.877.877h4.384Zm17.537-.877H77.832l-7.658-2.3a7.882,7.882,0,0,0-2.268-.333H62.071a2.635,2.635,0,0,1,2.48-1.754h3.507a3.507,3.507,0,1,0,0-7.015h-.877V24.768H71.2l6.758,6.758a.877.877,0,0,0,.62.257h4.384Zm5.261,1.754H84.718V29.152h3.507Z",
    transform: "translate(-37.369 -16)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9999",
    "data-name": "Path 9999",
    d: "M60.717,278.139v4.2l-1.134-1.134-1.24,1.24,2.631,2.63a.87.87,0,0,0,1.239,0h0l2.63-2.63-1.24-1.24L62.47,282.34v-4.2Z",
    transform: "translate(69.484 313.271) rotate(180)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10055",
    "data-name": "Path 10055",
    d: "M32.432,196.388a3.662,3.662,0,0,1,2.443,2.5.607.607,0,0,0,.58.442.533.533,0,0,0,.093-.014.57.57,0,0,0,.083.017H50.156a.535.535,0,0,0,.074-.016.563.563,0,0,0,.681-.424v0a3.661,3.661,0,0,1,2.443-2.5.612.612,0,0,0,.415-.681.64.64,0,0,0,.018-.092v-4.954a.571.571,0,0,0-.018-.092.611.611,0,0,0-.415-.681,3.658,3.658,0,0,1-2.442-2.5.6.6,0,0,0-.671-.425.583.583,0,0,0-.085-.017H35.631a.548.548,0,0,0-.09.019.6.6,0,0,0-.666.425,3.662,3.662,0,0,1-2.443,2.5.612.612,0,0,0-.415.681.638.638,0,0,0-.017.092v4.954a.583.583,0,0,0,.017.086A.614.614,0,0,0,32.432,196.388Zm.778-5.476a4.86,4.86,0,0,0,2.667-2.729H49.91a4.861,4.861,0,0,0,2.667,2.729v4.451a4.865,4.865,0,0,0-2.667,2.729H35.877a4.865,4.865,0,0,0-2.667-2.729Z",
    transform: "translate(-26.854 -177.586)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10056",
    "data-name": "Path 10056",
    d: "M131.715,226.376A3.716,3.716,0,1,0,128,222.661,3.715,3.715,0,0,0,131.715,226.376Zm0-6.193a2.477,2.477,0,1,1-2.477,2.477A2.477,2.477,0,0,1,131.715,220.184Z",
    transform: "translate(-115.676 -207.109)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10022_-_Outline",
    "data-name": "Path 10022 - Outline",
    d: "M77.021,257.238a1.271,1.271,0,1,1,1.271-1.271A1.273,1.273,0,0,1,77.021,257.238Z",
    transform: "translate(-67.542 -240.414)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10023_-_Outline",
    "data-name": "Path 10023 - Outline",
    d: "M253.021,257.238a1.271,1.271,0,1,1,1.271-1.271A1.273,1.273,0,0,1,253.021,257.238Z",
    transform: "translate(-230.423 -240.414)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Renew_-_Flaticon-2_1_",
    "data-name": "Search results for Renew - Flaticon-2 (1)",
    transform: "translate(51 334.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10490",
    "data-name": "Group 10490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10489",
    "data-name": "Group 10489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10488",
    "data-name": "Group 10488",
    transform: "translate(0 1.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10051",
    "data-name": "Path 10051",
    d: "M123.667,247.467a1.5,1.5,0,0,0-1.5,1.5,41.982,41.982,0,0,1-74.145,27h8.144a1.5,1.5,0,1,0,0-3h-12a1.5,1.5,0,0,0-1.5,1.5v12a1.5,1.5,0,0,0,3,0v-8.639a44.982,44.982,0,0,0,79.5-28.861A1.5,1.5,0,0,0,123.667,247.467Z",
    transform: "translate(-35.167 -203.967)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10052",
    "data-name": "Path 10052",
    d: "M45,3A42.145,42.145,0,0,1,77.145,18H69a1.5,1.5,0,0,0,0,3H81a1.5,1.5,0,0,0,1.5-1.5V7.5a1.5,1.5,0,0,0-3,0v8.639A44.982,44.982,0,0,0,0,45a1.5,1.5,0,0,0,3,0A42.047,42.047,0,0,1,45,3Z",
    fill: "#00641f"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgageTransfer);
export default __webpack_public_path__ + "static/media/mortgageTransfer.6454e2c742abf1975ef0fc124faffb93.svg";
export { ForwardRef as ReactComponent };